<template>
  <header-title />
  <div class="container">
    <aside-body />
    <div class="main">
      <el-col :span="24" style="margin: 20px">
        <span style="margin-right: 10px">类别</span>
        <el-select
          v-model="value"
          @change="_pageChange(1)"
          placeholder="请选择"
          size="large"
          style="width: 240px; min-height: 30px"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <span style="color: #007bff; font-weight: 500; margin-left: 20px"
          >总计{{ total }}人</span
        >
      </el-col>
      <div class="el-row">
        <el-date-picker
          v-model="value1"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          style="max-width: 400px; margin-left: 20px; margin-bottom: 10px"
          :disabled-date="disabledDate"
          @change="_getTimePerson()"
        />
        <el-button
          type="warning"
          round
          style="margin-left: 20px"
          @click="_delTime"
          >清空</el-button
        >
      </div>
      <el-table
        :data="changedList"
        stripe
        style="width: 100%; margin-left: 25px"
        scrollbar-always-on
      >
        <el-table-column prop="o_name" label="姓名" width="280" />
        <el-table-column prop="o_phone" label="联系方式" width="230" />
        <el-table-column prop="o_CAUSE" label="检查项目" width="280" />
        <el-table-column prop="o_TIME" label="预约时间" />
      </el-table>
      <el-pagination
        :page-size="10"
        v-model:current-page="pageNum"
        layout="prev, pager, next"
        :total="total"
        @change="_pageChange"
      />
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import headerTitle from '@/components/headerTitle.vue'
import asideBody from '@/components/asideBody.vue'
import http from '@/util/http'
import Cookies from 'js-cookie'

export default {
  name: 'questionView',
  components: { asideBody, headerTitle },
  data() {
    return {
      total: 0,
      pageNum: 1,
      value: '0',
      value1: [],
      time: [],
      queryData: {
        startTime: undefined,
        endTime: undefined,
        o_category: undefined
      },
      persons: '200',
      options: [
        {
          value: '0',
          label: '在线预约'
        },
        {
          value: '1',
          label: '邮寄检测'
        }
      ],
      listData: [],
      changedList: []
    }
  },
  mounted() {
    this._getInfo()
  },
  methods: {
    _pageChange(e) {
      this.pageNum = e
      this._getInfo()
      this.value1 = []
    },
    // 获取预约信息
    _getInfo() {
      http
        .get('order/info', {
          pageSize: 10,
          pageNum: this.pageNum,
          o_category: this.value
        })
        .then(res => {
          if (res.code == 200) {
            this.listData = res.data.list
            this.changedList = this.listData.filter(
              item => item.o_category == this.value
            )
            for (const i in this.listData) {
              this.changedList[i].o_CAUSE = JSON.parse(this.listData[i].o_CAUSE)
              this.changedList[i].time_Label = this.listData[i].o_Time
            }
            this.total = res.data.total
            console.log(this.changedList)
          }
        })
    },
    disabledDate(date) {
      const startTime = Cookies.get('startTime')
      const endTime = Cookies.get('nowTime')
      console.log(startTime, endTime)
      if (!startTime || !endTime) {
        return false
      }
      const startDate = new Date(startTime)
      const endDate = new Date(endTime)
      // 如果日期在范围内，则返回 false，否则返回 true
      return date < startDate || date > endDate
    },
    _getTimePerson() {
      console.log(this.value1)
      if (this.value1 && this.value1.length > 0) {
        this.queryData.startTime = String(Math.floor(this.value1[0].getTime()))
        this.queryData.endTime = String(Math.floor(this.value1[1].getTime()))
        this.queryData.o_category = this.value
        http.get('selOrderInfo/', this.queryData).then(res => {
          console.log(res)
          if (res.code == 200) {
            this.changedList = res.data.list
            this.total = res.data.total
            for (const i in this.changedList) {
              this.changedList[i].o_CAUSE = JSON.parse(
                this.changedList[i].o_CAUSE
              )
              this.changedList[i].time_Label = this.changedList[i].o_Time
            }
          }
        })
      } else {
        this.value1 = []
        this._getInfo()
      }
    },
    _delTime() {
      this.value1 = []
      this._getInfo()
    }
  }
}
</script>

<style scoped></style>
